import { render, staticRenderFns } from "./GamesCode.vue?vue&type=template&id=4e92b2a4"
import script from "./GamesCode.vue?vue&type=script&lang=js"
export * from "./GamesCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports